import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import { PracticeService } from "src/app/core/services/v2/practice.service";
import { UserService } from "src/app/core/services/v2/user.service";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit, OnDestroy {
 
  isAHIAdmin : boolean = false;
  ngOnDestroy() {
    
  }

  ngOnInit(): void {
    
  }

  /**
   *
   */
  constructor(
    private _practiceService: PracticeService,
    private _userService: UserService
  ) {
    
    this.checkUserIsAdmin();
  }

  checkUserIsAdmin(){
    this._userService.getUserDetails().subscribe(
      (user) => {
        
        this._practiceService.setCurrentUser(user);
        this.isAHIAdmin = this._practiceService.checkForAHI();
      },
      (error) => { console.error(error); }
    );
  }

}
